import { tr as __tr, useLocale as __useLocale } from "../i18n/runtime";
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Mail, Lock, Eye, EyeOff, User, Phone, Plane } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../i18n/LanguageContext';
const Register = () => {
  __useLocale();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    full_name: '',
    phone: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const {
    register
  } = useAuth();
  const {
    t,
    language
  } = useLanguage();
  const navigate = useNavigate();
  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    if (formData.password !== formData.confirmPassword) {
      setError(language === 'ar' ? "كلمات المرور غير متطابقة" : 'Passwords do not match');
      return;
    }
    setLoading(true);
    try {
      await register({
        email: formData.email,
        password: formData.password,
        full_name: formData.full_name,
        phone: formData.phone,
        language: language
      });
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || t('common.error'));
    } finally {
      setLoading(false);
    }
  };
  return <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#6B5B95] via-[#5B4B85] to-[#4A3F75] px-4 py-8" dir={language === 'ar' ? 'rtl' : 'ltr'}>
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-center gap-2">
            <span className="text-4xl font-bold text-white">{__tr(t('brand'))}</span>
            <Plane className="w-8 h-8 text-[#FF8C42]" />
          </Link>
        </div>

        {/* Form Card */}
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <h2 className="text-2xl font-bold text-gray-800 text-center mb-6">
            {__tr(t('auth.registerTitle'))}
          </h2>

          {__tr(error && <div className="bg-red-50 text-red-600 px-4 py-3 rounded-lg mb-4 text-sm">
              {__tr(error)}
            </div>)}

          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Full Name */}
            <div className="space-y-2">
              <label className="text-sm text-gray-600 flex items-center gap-2">
                <User className="w-4 h-4" />
                {__tr(t('auth.fullName'))}
              </label>
              <Input type="text" name="full_name" value={formData.full_name} onChange={handleChange} className="h-12 rounded-xl" required />
            </div>

            {/* Email */}
            <div className="space-y-2">
              <label className="text-sm text-gray-600 flex items-center gap-2">
                <Mail className="w-4 h-4" />
                {__tr(t('auth.email'))}
              </label>
              <Input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="email@example.com" className="h-12 rounded-xl" required />
            </div>

            {/* Phone */}
            <div className="space-y-2">
              <label className="text-sm text-gray-600 flex items-center gap-2">
                <Phone className="w-4 h-4" />
                {__tr(t('auth.phone'))}
              </label>
              <Input type="tel" name="phone" value={formData.phone} onChange={handleChange} className="h-12 rounded-xl" />
            </div>

            {/* Password */}
            <div className="space-y-2">
              <label className="text-sm text-gray-600 flex items-center gap-2">
                <Lock className="w-4 h-4" />
                {__tr(t('auth.password'))}
              </label>
              <div className="relative">
                <Input type={showPassword ? 'text' : 'password'} name="password" value={formData.password} onChange={handleChange} className="h-12 rounded-xl pl-10" required />
                <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                  {__tr(showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />)}
                </button>
              </div>
            </div>

            {/* Confirm Password */}
            <div className="space-y-2">
              <label className="text-sm text-gray-600 flex items-center gap-2">
                <Lock className="w-4 h-4" />
                {__tr(t('auth.confirmPassword'))}
              </label>
              <Input type={showPassword ? 'text' : 'password'} name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} className="h-12 rounded-xl" required />
            </div>

            {/* Submit */}
            <Button type="submit" disabled={loading} className="w-full h-12 bg-gradient-to-r from-[#6B5B95] to-[#5B4B85] hover:from-[#5B4B85] hover:to-[#4A3F75] text-white rounded-xl text-lg font-medium mt-6">
              {__tr(loading ? t('common.loading') : t('auth.registerBtn'))}
            </Button>
          </form>

          {/* Login Link */}
          <div className="text-center mt-6">
            <span className="text-gray-600">{__tr(t('auth.hasAccount'))} </span>
            <Link to="/login" className="text-[#6B5B95] hover:underline font-medium">
              {__tr(t('nav.login'))}
            </Link>
          </div>
        </div>
      </div>
    </div>;
};
export default Register;
